import { apiService } from './apiService';

export interface EmbeddingProviderDto {
  tenantId?: string;
  name: string;
  displayName: string;
  websiteUrl?: string;
  description?: string;
  isSystemProvider?: boolean;
  isActive?: boolean;
  apiKey?: string;
  endpointUrl?: string;
  defaultModel?: string;
  defaultVectorDimensions?: number;
  apiVersion?: string;
  costPer1KTokens?: number;
  maxRequestsPerMinute?: number;
  additionalConfigJson?: string;
  auditInfo?: string;
}

export interface EmbeddingProvider {
  id: string;
  tenantId: string;
  name: string;
  displayName: string;
  websiteUrl?: string;
  description?: string;
  isSystemProvider?: boolean;
  isActive?: boolean;
  apiKey?: string;
  endpointUrl?: string;
  defaultModel?: string;
  defaultVectorDimensions?: number;
  apiVersion?: string;
  costPer1KTokens?: number;
  maxRequestsPerMinute?: number;
  additionalConfigJson?: string;
  auditInfo?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
}

export const embeddingProviderService = {
  getList: () =>
    apiService.get('/api/EmbeddingProvider/list', {}, 'backend') as Promise<EmbeddingProvider[]>,

  getById: (id: string) =>
    apiService.get(`/api/EmbeddingProvider/details/${id}`, {}, 'backend') as Promise<EmbeddingProvider>,

  create: (dto: EmbeddingProviderDto) =>
    apiService.post('/api/EmbeddingProvider', dto, 'backend'),

  update: (id: string, dto: EmbeddingProviderDto) =>
    apiService.put(`/api/EmbeddingProvider/${id}`, dto, 'backend'),

  delete: (id: string) =>
    apiService.delete(`/api/EmbeddingProvider/${id}`, 'backend'),

  setActive: (id: string, isActive: boolean) =>
    apiService.patch(`/api/EmbeddingProvider/${id}/active`, { isActive }, 'backend'),
};

